import { EntityId } from "@reduxjs/toolkit";
import { streamingApi } from "./base.api";

const BASE_PATH = "/stream-snapshot";

export const streamSnapshotApi = streamingApi.injectEndpoints({
    endpoints: (build) => ({
        getVideoSnapshot: build.query<string, EntityId>({
            query: (deviceId: EntityId) =>
                `${BASE_PATH}/videosnapshots/${deviceId}`,
            transformResponse: (response: string) => {
                return `data:image/jpeg;base64,${response}`;
            },
        }),
    }),
    overrideExisting: true,
});

export const { useGetVideoSnapshotQuery, useLazyGetVideoSnapshotQuery } =
    streamSnapshotApi;
